import React from "react";
import { Link } from "react-router-dom";

import {
  AUDIT_HISTORIES_LINK_LABEL,
  AUDIT_HISTORIES_LINK_REL,
  AUDIT_HISTORIES_LINK_TARGET,
  buildAuditHistoriesUrl,
} from "./auditEntityConfig";

export default function AuditHistoriesLink({
  slug,
  className = "",
  label = AUDIT_HISTORIES_LINK_LABEL,
}) {
  return (
    <Link
      to={buildAuditHistoriesUrl(slug)}
      target={AUDIT_HISTORIES_LINK_TARGET}
      rel={AUDIT_HISTORIES_LINK_REL}
      className={`ml-2 inline-flex h-10 items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 ${className}`.trim()}
    >
      {label}
    </Link>
  );
}
